import { computed, type ComputedRef } from 'vue';

import { PartnerContext } from '@/partner/PartnerContext';
import { usePartnerInfoStore } from '@/stores/partnerInfoStore';

export function usePartnerContext(): ComputedRef<PartnerContext> {
  const partnerInfoStore = usePartnerInfoStore();

  return computed(() =>
    PartnerContext.fromProfile(partnerInfoStore.profile.partner_segment),
  );
}
